<template>
  <div @click="$emit('selectMethod')" class="method-card cursor-pointer">
    <div class="method-card__icon-wrapper">
      <component :is="typeIcon" class="method-card__icon"></component>
    </div>
    <div class="method-card__text-wrapper">
      <div class="method-card_text bold gray-900">
        {{ text }}
      </div>
      <div class="method-card_code gray-500">
        {{ code }}
      </div>
    </div>
    <ChevronRightIcon size="24" class="method-card__icon" />
  </div>
</template>

<script>
import { MailIcon, ChatAltIcon, ChevronRightIcon } from '@vue-hero-icons/outline';

export default {
  metaInfo: {
    title: 'Login',
  },
  components: {
    mail: MailIcon,
    chat: ChatAltIcon,
    ChevronRightIcon,
  },
  props: {
    type: {
      type: String,
    },
    text: {
      type: String,
    },
    code: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  data: () => ({
    typeIcon: '',
  }),
  mounted() {
    if (this.icon) {
      this.typeIcon = this.icon;
    }
  },
};
</script>

<style lang='scss' scoped>

@import '../../../scss/__new-styles.scss';

.method-card {
  padding: 1.5rem;
  display: flex;
  opacity: 1;
  transition: 0.05s linear;
  box-sizing: border-box;
  border: 0.063rem solid $gray-300;
  border-radius: 0.75rem;
  min-width: 23.5rem;
  height: 6.25rem;
  transition: 0.15s linear;

  &:hover {
    border: 0.063rem solid $primary-400;
    background: $primary-50;
    transition: 0.1s linear;
  }

  &__text-wrapper {
    margin: 0 0.75rem;
    word-break: break-all;
    width: 100%;
  }

  &__text {
    @extend .body-semi-bold;
    font-size: 1rem;
  }

  &__icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: auto;
    align-self: center;
  }

  @media (max-width: $sm) {
    min-width: auto;
    height: auto;
    padding: 1.5rem 0.75rem;

    &_code {
      font-size: 0.875rem;
    }
  }
}

</style>
